// ------------------------------------
// FOTOS (CARROSSEL)
// ------------------------------------
$(function () {
  if ($(".produto-det-fotos").length) {
    const totalItens = $(".produto-det-foto").length;

    const cols = {
      desktop: 1,
      tablet: 2,
      mobile: 1,
    };

    // Carrossel principal
    const $carouselMain = $(".produto-det-fotos");
    let carouselMainOpts = {
      type: "loop",
      perPage: 2,
      perMove: 1,
      speed: 600,
      arrows: true,
      pagination: false,
      autoplay: true,
      breakpoints: {
        // Tablet
        1200: {
          type: "loop",
          perMove: 1,
          perPage: cols.tablet,
          speed: 600,
          arrows: true,
          pagination: true,
          autoplay: true,
        },
        // Mobile
        760: {
          type: "loop",
          perMove: 1,
          perPage: cols.mobile,
          speed: 600,
          arrows: true,
          pagination: true,
          autoplay: true,
        },
      },
    };
    if (totalItens === 1) {
      carouselMainOpts.type = "slide";
      carouselMainOpts.arrows = false;
      carouselMainOpts.pagination = false;
      carouselMainOpts.drag = false;
      carouselMainOpts.keyboard = false;
    }
    let carouselMain = new Splide($carouselMain[0], carouselMainOpts);

    carouselMain.mount();
  }
});

// ------------------------------------
// Zoom
// ------------------------------------
(function () {
  "use strict";
  const enableZoom =
    $(".produto-det-fotos").data("zoom-hover") && $(window).width() > 960;
  if (enableZoom) {
    $(".produto-det-foto").each(function () {
      const $el = $(this);
      const imgLg = $(this).attr("href");
      if (imgLg) {
        $el.zoom({
          url: imgLg,
        });
      }
    });
  }
})();
